export const reportingType = {
  GET_UNREPORTED_ORDERS: "GET_UNREPORTED_ORDERS",
  GET_REPORTED_ORDERS: "GET_REPORTED_ORDERS",
  REQUEST_REPORTING: "REQUEST_REPORTING",
  REQUEST_REPORTING_DONE: "REQUEST_REPORTING_DONE",
};
